<template>
  <layout>
    <div class="page">
      <loading v-if="!$store.getters.newsLoaded" />
      <div v-else class="uk-container uk-container-expand uk-margin-large-top">
        <h1 class="uk-heading-primary green">News</h1>
        <news-item
          v-for="(news, i) in contentFields"
          v-if="!news.fields.hideFromListing"
          :key="i"
          :field="news.fields"
          :sys="news.sys"
        >
        </news-item>
      </div>
    </div>
  </layout>
</template>

<script>
import NewsItem from '@/components/NewsItem'

export default {
  metaInfo() {
    return {
      title: 'News | Nathan Nankirvis',
      meta: [
        {
          name: 'description',
          content: "Latest news and updates from Nathan Nankervis' studio.",
        },
      ],
    }
  },
  components: {
    NewsItem,
  },
  computed: {
    contentFields() {
      if (this.$store.getters.newsLoaded) {
        const news = { ...this.$store.getters.news }
        return news.posts.items
      }
      return false
    },
  },
  created() {
    if (!this.$store.getters.newsLoaded) {
      this.$store.dispatch('getNews')
    }
  },
}
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/pages/News.vue